import { jsx as _jsx } from "react/jsx-runtime";
import { Check as CheckIcon, Warning as WarningIcon } from '@mui/icons-material';
const ContentIcon = (props) => {
    const { success, successIcon = _jsx(CheckIcon, {}), error, errorIcon = _jsx(WarningIcon, {}), children } = props;
    if (success && !error)
        return successIcon;
    if (error && !success)
        return errorIcon;
    return children;
};
export default ContentIcon;
//# sourceMappingURL=ContentIcon.js.map